import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { State } from 'src/app/enums/state.enum';
import { EventResource } from 'src/app/interfaces/event-resource';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { EnvironmentService } from 'src/app/services/environment.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { TooltipPosition } from '@angular/material/tooltip';
import { InterestService } from 'src/app/services/interest.service';
import { map, mergeMap, startWith, switchMap, tap } from 'rxjs/operators';
import { Interest } from 'src/app/interfaces/interest';
import { Observable, of } from 'rxjs';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';


/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}
@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {
  /**
   * finished Loading the Page
   */
  loaded: boolean = false;
  /**
   * The current list of Partners
   */
  partners = [];
  /**
   * All Partners
   */
  Allpartners = [];
  /**
   * finished Loading the Page
   */
  finishedLoading: boolean = false;
  /**
   * The Position of the Tooltip
   */
  postoolTip: TooltipPosition = "above";
  /**
   * The filtered Partners
   */
  filteredOptions: Observable<string[]>;
  /**
   * 
   */
  partnerHasNotAtLeastOneEvent: boolean = false;
  /**
   * The PageMetadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * The Sortdirections for the Date
   */
  public sortOptions: SortOption[] = [
    { value: 'dateAsc', viewValue: 'Datum Absteigend' },
    { value: 'dateDesc', viewValue: 'Datum Aufsteigend' },
  ];
  /**
   * The State of the Event
   */
  public sortOptionsState: SortOption[] = [
    // { value: 'CREATED', viewValue: 'Erstellt' },
    { value: 'DRAFT', viewValue: 'Entwurf' },
    { value: 'PREVIEW', viewValue: 'Vorschau' },
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'HIDDEN', viewValue: 'Versteckt' },
    { value: 'CANCELLED', viewValue: 'Abgelehnt' },
    { value: 'EXPIRED', viewValue: 'Abgelaufen' },
    { value: 'ARCHIVED', viewValue: 'Archiviert' },
    { value: 'DELETED', viewValue: 'Gelöscht' },
  ];
  /**
   * THe Types of DiscountTypes
   */
  public sortOptionsDiscountType: SortOption[] = [
    { value: 'MONETARY', viewValue: 'Preisvorteil' },
    { value: 'SERVICE_PLUS', viewValue: 'Exklusiv' },
    { value: 'EXTERNAL_EVENT', viewValue: 'Partneraktion' },
    { value: 'RAFFLE', viewValue: 'Gewinnspiel' }
  ]
  /**
   * The Current Page of events
   */
  page = null;
  /**
   * All Events as Arrray
   */
  public allEvents = [];
  /**
   * The Form to filter
   */
  public filterForm: UntypedFormGroup;
  /**
   * constructor
   * Init the Form
   * @param eventService 
   * @param overlayService 
   * @param fb 
   * @param router 
   * @param environment 
   * @param sidenavService 
   * @param route 
   */
  constructor(private eventService: EventService,
    private overlayService: OverlayService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private environment: EnvironmentService,
    private sidenavService: SidenavService,
    private route: ActivatedRoute) {
    this.filterForm = this.fb.group({
      searchTerm: [, []],
      filterState: [[]],
      filterDiscountType: [[]],
      filterByPartners: [[]],
      serachTermPartners: [[]],
    })

    let extras = this.router.getCurrentNavigation()?.extras?.state;
    if (extras) {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        filterState: extras.filterState
      })
    }
  }
  /**
   * ngOnInit
   */
  ngOnInit() {
    this.filterEvents();
    this.eventService.getPartners().subscribe((partners: PagedResources<BusinessEntityResource>) => {
      this.partners = partners.content;
      this.Allpartners = partners.content;
    })

    // this.sidenavService.fitlterEvents$.subscribe(value => {
    //   if (value != null) {
    //     this.eventService.mergeEventsFromV1andV2(0, 12, value.filterState, value.filterDiscountType, value.filterByPartners, this.filterForm.value.emailFormControl).subscribe((value: PagedResources<EventResource>) => {
    //       console.log("EVENTS Search: ", value)
    //       if(value.page.totalElements >0){
    //         this.page = value.page
    //         this.allEvents = value.content;
    //       }else{
    //         this.partnerHasNotAtLeastOneEvent =  true;
    //       }
    //     })
    //   }
    // })

    this.filterForm.controls.serachTermPartners.valueChanges.subscribe(val => {
      this.autoCompletePartners(val)
    })
  }

  /**
   * Load the Page of Events
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }
  /**
   * Search for Events
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.eventService.mergeEventsFromV1andV2(pageIndex, pageSize, this.filterForm.value.filterState, this.filterForm.value.filterDiscountType, this.filterForm.value.filterByPartners, this.filterForm.value.emailFormControl).subscribe((value: any) => {
      this.page = value.page
      this.allEvents = value.content;
    })
  }
  /**
   * disable an Event
   * @param event 
   */
  disable(event: EventResource) {
    event.state = State.ARCHIVED;
    event.clientRef = event.eventPartner.clientRef;
    this.eventService.disableEvent(event).subscribe(resDisable => {
      this.overlayService.openSnackBar('Aktion wurde erfolgreich deaktiviert/archiviert!');
      //slice Element from Array
      //TODO check if this works with the filters in the future
      this.allEvents.splice(this.allEvents.indexOf(event), 1)
    })
  }
  /**
   * Filter the Events
   */
  filterEvents() {
    let FilterPartners = [];
    if (this.filterForm.value.filterByPartners?.length != 0) {
      this.filterForm.value.filterByPartners.forEach(element => {
        FilterPartners.push(element.publicId);
      });
    }
    this.eventService.mergeEventsFromV1andV2(0, 12, this.filterForm.value.filterState, this.filterForm.value.filterDiscountType, FilterPartners, this.filterForm.value.searchTerm).subscribe((value: PagedResources<EventResource>) => {
      value.content.forEach((element: EventResource) => {
        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], element.publicId).subscribe((count: PagedResources<EventResource>) => {
          element['attendanceCount'] = count.page.totalElements
        })
      });
      this.page = value.page
      this.allEvents = value.content;
      this.finishedLoading = true;
    })
  }
  /**
   * download the ReservationList as vnd.ms-excel
   * @param event 
   */
  downloadReservationList(event: EventResource) {
    this.eventService.downloadReservationList(event).subscribe(bal => {
      var a = document.createElement("a");
      const contentType = 'application/vnd.ms-excel';
      const blob = new Blob([bal], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Aktionspartnerliste";
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }
  /**
   * Open The Dialog to change the State and save the input of the User
   * @param event 
   */
  openStateChangeBottomSheet(event) {
    this.overlayService.openBottomSheet(event).subscribe(value => {
      this.eventService.mergeEventsFromV1andV2(0, 12, this.filterForm.value.filterState, this.filterForm.value.filterDiscountType, this.filterForm.value.filterByPartners, this.filterForm.value.emailFormControl).subscribe(value => {
        this.page = value.page
        this.allEvents = value.content;
        this.resetFitler();
      })
    })
  }
  /**
   * Reset the Filter
   */
  resetFitler() {
    this.filterForm.reset();
    this.search(0, 12)
  }
  /**
   * Move to the Reservation View 
   * @param element 
   */
  moveToReservations(element: EventResource) {
    let navigationExtras: NavigationExtras = {
      state: {
        eventPublicId: element.publicId
      }
    };
    this.router.navigate(['partner/reservation'], navigationExtras)
  }
  /**
   * Update all Eventstates
   */
  bulkUpdateEvents() {
    this.eventService.bulkUpdateEvents(false).subscribe(val => {
      console.log(val)
    })
  }
  /**
   * Change the AutoStateChange of an Event
   * @param event 
   * @param newAutoState 
   */
  changeAutoStateChange(event: EventResource, newAutoState: boolean) {
    event.autoStatus = newAutoState;
    this.eventService.editEvent(event).subscribe((formChange: EventResource) => {
      event = formChange;
    })
  }
  /**
   * Duplicate the Event
   * @param event 
   */
  duplicateEvent(event: EventResource) {
    let oldId = event.publicId
    event.state = State.DRAFT;
    event.autoStatus = false;
    event.publicId = null;
    let fromDuplicateTemp: EventResource;
    this.eventService.createEvent(event).pipe(
      switchMap((fromDuplicate: EventResource) => {
        fromDuplicateTemp = fromDuplicate;
        console.log(event)
        return this.eventService.getInterestsForEvent(oldId);
      }),
      switchMap((interestFromOldEvent: PagedResources<Interest>) => {
        interestFromOldEvent.content.forEach(element => {
          this.eventService.addInterestToEvent(fromDuplicateTemp.publicId, element).subscribe(fromADD => {
          })
        });
        return of(true)
      })
    ).subscribe(val => {
      this.overlayService.openSnackBar("Aktion erfolgreich dupliziert!");
      this.filterEvents();
    })
  }
  /**
   * Move to the SmartQuick View
   * @param event 
   */
  moveToSmartQuick(event: EventResource) {
    let navigationExtras: NavigationExtras = {
      state: {
        event: event
      }
    };
    this.router.navigate(['partner/smartquick'], navigationExtras)
  }
  /**
   * Move to the QR Code View
   * @param event 
   */
  openQRDialog(event: EventResource) {
    this.overlayService.openQrCodeDialog("Aktions QR-Code", "", "OK", event)
  }
  /**
   * Filter the list in the Autocomplete text
   * @param value 
   */
  private autoCompletePartners(value) {
    this.partners = this.Allpartners;
    if (value != '' && value != null) {
      this.partners = this.Allpartners;
      const filterValue = value.toLowerCase();
      this.partners = this.partners.filter(option => option.name.toLowerCase().includes(filterValue));
    }
  }
  /**
   * Clear the sarchText for the Partners
   */
  clearSearchField() {
    this.filterForm.controls.serachTermPartners.reset()
  }
}
